module.exports = __webpack_public_path__ + "fonts/opensans-bold-webfont.woff2";